module.exports = __webpack_public_path__ + "img/ny_tree.1bdb498a.svg";